import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginComponent } from './pages/login/login.component';
import { CoreModule } from '../core/core.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { HorizonSsoComponent } from './pages/horizon-sso/horizon-sso.component';

import * as store from './store';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHttpInterceptor } from './services/auth-http-interceptor';
import { CookieService } from 'ngx-cookie-service';
import { MapLinkComponent } from './pages/map-link/map-link.component';
import { DashboardLinkComponent } from './pages/dashboard-link/dashboard-link.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { IpRestrictedComponent } from './pages/ip-restricted/ip-restricted.component';
import { ExternalLinkComponent } from './pages/external-link/external-link.component';
import { ChangeOrganizationComponent } from './change-organization/change-organization.component';
import { AppDisclaimerComponent, ThemeSwitcherComponent } from '@app/shared/components';
import { PolicyAcceptanceComponent } from './pages/policy-acceptance/policy-acceptance.component';
import { BusinessUnitsWarningComponent } from './pages/business-units-warning/business-units-warning.component';
import { ExternalLinkDownloadComponent } from './pages/external-link-download/external-link-download.component';

@NgModule({
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    HorizonSsoComponent,
    MapLinkComponent,
    DashboardLinkComponent,
    IpRestrictedComponent,
    ExternalLinkComponent,
    ExternalLinkDownloadComponent,
    ChangeOrganizationComponent,
    PolicyAcceptanceComponent,
    BusinessUnitsWarningComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    AuthenticationRoutingModule,
    StoreModule.forFeature('authentication', store.reducers),
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    TranslateModule.forChild({
      extend: true
    }),
    AppDisclaimerComponent,
    ThemeSwitcherComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    },
    CookieService,
    Location
  ]
})
export class AuthenticationModule {}
